import SyntheseModeleDetailController from './synthesemodele.detail.controller';

export default {
    template: require('./synthesemodele.detail.html'),
    controller: SyntheseModeleDetailController
};
